import { render } from "./selectModule.vue?vue&type=template&id=ae143d10&scoped=true"
import script from "./selectModule.vue?vue&type=script&lang=js"
export * from "./selectModule.vue?vue&type=script&lang=js"

import "./selectModule.vue?vue&type=style&index=0&id=ae143d10&scoped=true&lang=scss"

import exportComponent from "E:\\project\\lms-frontend-admin\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-ae143d10"]])

export default __exports__